import { MemberStatusEnum } from '../../Enum/MemberStatusEnum';
import { StatusEnum } from '../../Enum/StatusEnum';
import { CreatedBy } from '../Shared/CreatedBy.model';

export interface DraftWorkflowState {
    // Demographic completion flags
    IsCompletedBasicInfo?: boolean;
    IsCompletedAddressInfo?: boolean;
    IsCompletedContactInfo?: boolean;

    // Member onboarding
    DateOfOnboard?: string;
    MemberStatus?: MemberStatusEnum;

    // Audit
    CreatedOn?: string;
    CreatedBy?: CreatedBy;

    // Workflow checklist flags for transitional care
    IsNotEncounterable?: boolean;
    AddKeyContact?: boolean;
    EngageWithMember?: boolean;
    AddPlanOfCare?: boolean;
    TransitionalCareStatus?: StatusEnum;
    MedicalReconcilation?: boolean;
    PlanDischargeLocation?: boolean;
    IsInTransition?: boolean;

    // HRA
    HraEducationFollowUpRequestIds?: string[];
}

export class DraftWorkflowState implements DraftWorkflowState {
    constructor() {
        this.IsCompletedBasicInfo = false;
        this.IsCompletedAddressInfo = false;
        this.IsCompletedContactInfo = false;
        this.DateOfOnboard = '';
        this.MemberStatus = MemberStatusEnum.Undetermined;
        this.CreatedOn = new Date().toISOString();
        this.CreatedBy = new CreatedBy();

        this.IsNotEncounterable = false;
        this.AddKeyContact = false;
        this.EngageWithMember = false;
        this.AddPlanOfCare = false;
        this.TransitionalCareStatus = StatusEnum.None;
        this.MedicalReconcilation = false;
        this.PlanDischargeLocation = false;
        this.IsInTransition = false;
        this.HraEducationFollowUpRequestIds = [];
    }
}
